import script from "./LayoutLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutLogin.vue?vue&type=script&setup=true&lang=js"

import "./LayoutLogin.vue?vue&type=style&index=0&id=164ab937&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164ab937"]])

export default __exports__